import classnames from 'classnames';
import { CheckMark, CheckMarkTypes } from '../../../components/CheckMark';

import * as api from '../../../api';
import { padStartWithZero } from '../../../utils';
import styles from '../index.module.css';

import amexLogo from '../../../assets/Amex_logo_color.svg';
import cardLogo from '../../../assets/credit_card.svg';
import mastercardLogo from '../../../assets/mc_vrt_pos.svg';
import visaLogo from '../../../assets/visa.svg';

const brandToLogoSrc: Record<string, string> = {
  visa: visaLogo,
  mastercard: mastercardLogo,
  amex: amexLogo,
  unknown: cardLogo,
};

function makeCardLabelFromPayload(
  payload: api.Payment.PaymentMethodPayload,
): React.ReactNode {
  let formattedMonthPart = payload.exp_month
    ? `${padStartWithZero(`${payload.exp_month}`, 2)}/`
    : '';
  const abbreviatedYear = payload.exp_year
    ? `${payload.exp_year}`.slice(2)
    : '';
  const imgSrc = (payload.brand && brandToLogoSrc[payload.brand]) || cardLogo;
  return (
    <div className={styles.PaymentSelectLabel}>
      <div className={styles.PaymentSelectCard}>
        {imgSrc && (
          <img
            alt="card logo"
            className={styles.PaymentSelectIcon}
            src={imgSrc}
          />
        )}
        <span className={styles.PaymentSelectDesc}>
          {`•••• ${payload.last4}`}
        </span>
      </div>
      <div
        className={styles.ExpirationDate}
      >{`${formattedMonthPart}${abbreviatedYear}`}</div>
    </div>
  );
}

interface BaseProps {
  checked: boolean;
  onClick: () => void;
}

interface PaymentProps extends BaseProps {
  paymentMethod: api.Payment.PaymentMethodPayload;
}

interface LabelProps extends BaseProps {
  label: React.ReactNode;
}

function isPaymentProps(
  props: LabelProps | PaymentProps,
): props is PaymentProps {
  return !('label' in props);
}

const PaymentSelectItem: React.FC<LabelProps | PaymentProps> = (props) => {
  const { checked, onClick } = props;
  const display = isPaymentProps(props)
    ? makeCardLabelFromPayload(props.paymentMethod)
    : props.label;
  return (
    <div
      className={classnames(styles.PaymentSelectItem, {
        [styles.selected]: props.checked,
      })}
    >
      <CheckMark
        className={styles.PaymentMethodCheckbox}
        type={CheckMarkTypes.ROUNDCHECKMARK}
        label={display}
        checked={checked}
        onClick={onClick}
      />
    </div>
  );
};

export default PaymentSelectItem;
